export const LOCAL_SCRIPT_ICONS = {
  "ABB": "webp",
  "ABCAPITAL": "webp",
  "ACC": "webp",
  "ADANIENT": "webp",
  "ADANIGREEN": "webp",
  "ADANIPORTS": "webp",
  "ADANIPOWER": "webp",
  "ALKEM": "webp",
  "ALUMINIUM": "png",
  "AMBUJACEM": "webp",
  "ANGELONE": "webp",
  "APOLLOHOSP": "webp",
  "APOLLOTYRE": "webp",
  "ASHOKLEY": "webp",
  "ASIANPAINT": "webp",
  "ASTRAL": "webp",
  "AUROPHARMA": "webp",
  "AXISBANK": "webp",
  "BAJAJ-AUTO": "webp",
  "BAJAJFINSV": "webp",
  "BAJFINANCE": "webp",
  "BALKRISIND": "webp",
  "BANDHANBNK": "webp",
  "BANKBARODA": "webp",
  "BANKNIFTY": "png",
  "BEL": "webp",
  "BERGEPAINT": "webp",
  "BHARTIARTL": "webp",
  "BHEL": "webp",
  "BIOCON": "webp",
  "BOSCHLTD": "webp",
  "BPCL": "webp",
  "BRITANNIA": "webp",
  "BSE": "webp",
  "CAMS": "webp",
  "CANBK": "webp",
  "CDSL": "webp",
  "CENTRALBK": "webp",
  "CHOLAFIN": "webp",
  "CIPLA": "webp",
  "COALINDIA": "webp",
  "COFORGE": "webp",
  "COLPAL": "webp",
  "CONCOR": "webp",
  "COPPER": "png",
  "COTTON": "png",
  "CRUDEOIL": "png",
  "CUMMINSIND": "webp",
  "DABUR": "webp",
  "DALBHARAT": "webp",
  "DEEPAKNTR": "webp",
  "DIVISLAB": "webp",
  "DIXON": "webp",
  "DLF": "webp",
  "DMART": "webp",
  "EICHERMOT": "webp",
  "ESCORTS": "webp",
  "FEDERALBNK": "webp",
  "FINNIFTY": "png",
  "FIRSTCRY": "webp",
  "GAIL": "webp",
  "GODREJCP": "webp",
  "GODREJPROP": "webp",
  "GOLD": "png",
  "GRASIM": "webp",
  "HAL": "webp",
  "HAVELLS": "webp",
  "HCLTECH": "webp",
  "HDFCAMC": "webp",
  "HDFCBANK": "webp",
  "HDFCLIFE": "webp",
  "HEROMOTOCO": "webp",
  "HINDALCO": "webp",
  "HINDPETRO": "webp",
  "HINDUNILVR": "webp",
  "HINDZINC": "webp",
  "HUDCO": "webp",
  "ICICIBANK": "webp",
  "ICICIGI": "webp",
  "ICICIPRULI": "webp",
  "IDBI": "webp",
  "IDFCFIRSTB": "webp",
  "IEX": "webp",
  "IGL": "webp",
  "INDHOTEL": "webp",
  "INDIANB": "webp",
  "INDIGO": "webp",
  "INDUSINDBK": "webp",
  "INDUSTOWER": "webp",
  "INFY": "webp",
  "IOB": "webp",
  "IOC": "webp",
  "IRCTC": "webp",
  "IRFC": "webp",
  "ITC": "webp",
  "JIOFIN": "webp",
  "JSWSTEEL": "webp",
  "JUBLFOOD": "webp",
  "KEI": "webp",
  "KOTAKBANK": "webp",
  "LALPATHLAB": "webp",
  "LAURUSLABS": "webp",
  "LEAD": "png",
  "LICHSGFIN": "webp",
  "LICI": "webp",
  "LODHA": "webp",
  "LT": "webp",
  "LTIM": "webp",
  "LTTS": "webp",
  "LUPIN": "webp",
  "M&M": "webp",
  "MAHABANK": "webp",
  "MANAPPURAM": "webp",
  "MANDM": "webp",
  "MARICO": "webp",
  "MARUTI": "webp",
  "MCX": "webp",
  "MENTHAOIL": "png",
  "MFSL": "webp",
  "MGL": "webp",
  "MIDCPNIFTY": "png",
  "MOTHERSON": "webp",
  "MOTILALOFS": "webp",
  "MPHASIS": "webp",
  "MRF": "webp",
  "MUTHOOTFIN": "webp",
  "NAM-INDIA": "webp",
  "NATIONALUM": "webp",
  "NATURALGAS": "png",
  "NAUKRI": "webp",
  "NBCC": "webp",
  "NESTLEIND": "webp",
  "NICKEL": "png",
  "NIFTY": "png",
  "NMDC": "webp",
  "NTPC": "webp",
  "NYKAA": "webp",
  "OBEROIRLTY": "webp",
  "OFSS": "webp",
  "ONGC": "webp",
  "PAGEIND": "webp",
  "PAYTM": "webp",
  "PEL": "webp",
  "PETRONET": "webp",
  "PFC": "webp",
  "PIDILITIND": "webp",
  "PIIND": "webp",
  "PNB": "webp",
  "POLICYBZR": "webp",
  "POLYCAB": "webp",
  "POWERGRID": "webp",
  "PRESTIGE": "webp",
  "PVRINOX": "webp",
  "RAILTEL": "webp",
  "RAMCOCEM": "webp",
  "RECLTD": "webp",
  "RELIANCE": "webp",
  "SAIL": "webp",
  "SBICARD": "webp",
  "SBILIFE": "webp",
  "SBIN": "webp",
  "SENSEX": "png",
  "SHREECEM": "webp",
  "SHRIRAMFIN": "webp",
  "SIEMENS": "webp",
  "SILVER": "png",
  "SONACOMS": "webp",
  "SRF": "webp",
  "SUNPHARMA": "webp",
  "SUPREMEIND": "webp",
  "SWIGGY": "webp",
  "SYNGENE": "webp",
  "TATACOMM": "webp",
  "TATACONSUM": "webp",
  "TATAMOTORS": "webp",
  "TATAPOWER": "webp",
  "TATASTEEL": "webp",
  "TATATECH": "webp",
  "TCS": "webp",
  "TECHM": "webp",
  "TITAN": "webp",
  "TORNTPHARM": "webp",
  "TORNTPOWER": "webp",
  "TRENT": "webp",
  "TVSMOTOR": "webp",
  "UBL": "webp",
  "UCOBANK": "webp",
  "ULTRACEMCO": "webp",
  "UNIONBANK": "webp",
  "UNITDSPR": "webp",
  "UPL": "webp",
  "VEDL": "webp",
  "VOLTAS": "webp",
  "WIPRO": "webp",
  "YESBANK": "webp",
  "ZEEL": "webp",
  "ZINC": "png"
};
